import { render, staticRenderFns } from "./BatchModifyShelf.vue?vue&type=template&id=5e3dca73&scoped=true"
import script from "./BatchModifyShelf.vue?vue&type=script&lang=js"
export * from "./BatchModifyShelf.vue?vue&type=script&lang=js"
import style0 from "./batch-modify.css?vue&type=style&index=0&id=5e3dca73&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3dca73",
  null
  
)

export default component.exports